import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import Positions from './pages/Positions';
import PositionDetail from './pages/PositionDetail';
import NewPosition from './pages/NewPosition';
import Reviews from './pages/Reviews';
import Journal from './pages/Journal';

function App() {
    const { isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/positions" element={<Positions />} />
                    <Route path="/positions/:id" element={<PositionDetail />} />
                    <Route path="/new" element={<NewPosition />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/journal/:date" element={<Journal />} />
                </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
